import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import PageSpinner from '@/components/PageSpinner';
import { buildLoginUrl } from '@/lib/authRedirect';

/**
 * Qué se pinta en una ruta privada cuando no hay sesión.
 *
 * Antes era `<Login />` a secas, montado sobre la URL privada sin tocarla: el
 * formulario salía en /Reviews?reviewId=123 y, como en la barra no había
 * ningún `?redirect=`, al autenticarse se aterrizaba en el destino por defecto
 * y el enlace del correo se perdía. Ahora se navega de verdad a
 * /login?redirect=<destino>.
 *
 * `replace` a propósito: el botón "atrás" del navegador no debe devolver a la
 * ruta privada vacía de la que venimos.
 *
 * En la práctica el guard de App.jsx suele expulsar antes de llegar aquí; esto
 * cubre el caso que se le escapa — navegar por dentro del SPA desde una página
 * pública a una privada, donde el guard no se entera porque lee
 * `window.location` sin suscribirse a los cambios de ruta.
 */
export default function LoginRedirect() {
  const { isLoadingAuth } = useAuth();
  const location = useLocation();

  // Mientras el check de sesión no ha resuelto no se decide nada: rebotar al
  // login a alguien que sí tiene sesión válida sería peor que esperar.
  if (isLoadingAuth) return <PageSpinner />;

  return <Navigate to={buildLoginUrl(location)} replace />;
}
